import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SoftwareWizardEmployeeFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import ComparisonBlock from 'modules/software_management/components/InitialSetup/ComparisonBlock'
import FaqBlock from 'modules/software_management/components/InitialSetup/FaqBlock'
import GetStartedBlock from 'modules/software_management/components/InitialSetup/GetStartedBlock'
import InfoPointsBlock from 'modules/software_management/components/InitialSetup/InfoPointsBlock'
import PaymentsBlock from 'modules/software_management/components/InitialSetup/PaymentsBlock'
import SoftwareWizard from 'modules/software_management/components/SoftwareWizard'

type Props = {
  upsellOnClick?: () => void
  ctaTitle?: string
  employee: SoftwareWizardEmployeeFragment
  onSoftwareCreated: (setupId: number) => void
}

const InitialSetup = ({ upsellOnClick, ctaTitle, employee, onSoftwareCreated }: Props) => {
  const [showNewModal, setShowNewModal] = useState<boolean>(false)

  const handleAddSoftware = () => {
    track(trackingEvents.softwareManagement.openSoftwareSetupWizard, { initial_setup: true })

    setShowNewModal(true)
  }

  const onClick = upsellOnClick || handleAddSoftware

  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center" paddingTop="s24">
      <GetStartedBlock onClickCta={onClick} ctaTitle={ctaTitle} />
      <PaymentsBlock onClickCta={onClick} ctaTitle={ctaTitle} />
      <InfoPointsBlock onClickCta={onClick} showButton={!ctaTitle} />
      <ComparisonBlock />
      <FaqBlock />
      {showNewModal && (
        <SoftwareWizard
          onSuccess={onSoftwareCreated}
          employee={employee}
          onClose={() => setShowNewModal(false)}
        />
      )}
    </Box>
  )
}

export default InitialSetup
